<div class="seedReserve">
  <div class="fulfillmentLanding">
    <div class="row">
      <div class="col-md-10 col-lg-10 margin-l0 TopSec">
        <h3 class="mb-md-0 mt-md-2 mt-3"> Seed Reservations </h3>
      </div>
      <div class="col-md-12 dashboard-outer">
        <div class="order-listing">
          <div class="row js-searchWrapper">
            <div class="col-lg-6">
              <div class="search-box landingPageSearch landingPageSearchTop" [ngClass]="{'opened' : isOpenFirst}">
                <form name="" action="">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <input type="hidden" #selectAccountHidden />
                  <div class="select-container material-select">
                    <ng-select #select name="ddlAccount" [items]="accountSearchData"
                               [(ngModel)]="ddlSelectedAccountId"
                               [virtualScroll]="true"
                               bindLabel="accountNameCityState"
                               bindValue="accountNumber"
                               [loading]="accountLoading"
                               (change)="accountSearchOnClose($event);"
                               (clear)="accountSearchOnClear($event)"
                               class="custom-select-grower searchIcon lpSearch"
                               placeholder="Select Account"
                               [closeOnSelect]="true"
                               [searchFn]="accountSearchFn"
                               (open)="onOpen(); topOpen()"
                               (close)="onClose(); topClose()">
                      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div class="dropdown-template">
                          <div class="row">
                            <div class="col-md-8">
                              <h4 class="name greenColor" [ngOptionHighlight]="search">
                                {{item.accountName}}
                                <span class="erp-order" *ngIf="item.wfusB2BEnablement == 'Yes'">
                                  <i class="fas fa-lock"></i>
                                </span>
                              </h4>
                              <p class="address" [ngOptionHighlight]="search">
                                {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                              </p>
                              <p class="phoneNo" [ngOptionHighlight]="search">
                                {{item.primaryPhoneNumber}}
                              </p>
                              <p class="grower-nos">
                                <span class="grower-gln" [ngOptionHighlight]="search">
                                  Account #: {{item.accountNumber}}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                        <div class="ng-option disabled">
                          No data found for "{{searchTerm}}"
                        </div>
                      </ng-template>
                      <ng-template ng-footer-tmp let-search="searchTerm">
                        <div class="custom-drop-footer">
                          <div class="row">
                            <div class="col-md-12">
                              Select an option above to filter
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </form>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="search-box landingPageSearch xs-mt-0 lg-mt-20" [ngClass]="{'opened' : isOpenSecond}">
                <form name="" action="">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <input type="hidden" #selectGrowerHidden />
                  <div class="select-container material-select">
                    <ng-select name="ddlGrowerDetails"
                               [items]="growerList"
                               [(ngModel)]="growerGMK"
                               [virtualScroll]="true"
                               bindLabel="growerNameCityState"
                               placeholder="Select Grower"
                               [loading]="growerLoading"
                               bindValue="gmk"
                               class="custom-select-grower searchIcon lpSearch"
                               [searchFn]="growerSearchFn"
                               [closeOnSelect]="true"
                               (search)="search($event)"
                               (change)="onGrowerSelection($event)"
                               (open)="onOpen(); middleOpen()"
                               (close)="onClose(); middleClose()">
                      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div class="dropdown-template">
                          <div class="row">
                            <div class="col-md-8">
                              <h4 class="name greenColor" [ngOptionHighlight]="search">
                                {{item.businessName?.toUpperCase()}}
                              </h4>
                              <p class="address" [ngOptionHighlight]="search">
                                {{item.address1?.toUpperCase()}},  {{item.city?.toUpperCase()}}, {{item.state?.toUpperCase()}} - {{item.zip}}
                              </p>
                              <p class="phoneNo" [ngOptionHighlight]="search">
                                {{item.primaryPhoneNumber}}
                              </p>
                              <p class="grower-nos">
                                <span class="grower-gln" [ngOptionHighlight]="search">
                                  Grower GMK: {{item.gmk}}
                                </span>
                                <span class="grower-gln" [ngOptionHighlight]="search">
                                  Grower GLN: {{item.growerGLN}}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                        <div class="ng-option disabled">
                          No data found for "{{searchTerm}}"
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="order-top-sec">
            <div class="d-flex justify-content-end align-items-md-start align-items-center flex-md-row flex-column-reverse">
              <div class="mt-2 mt-md-0">
                <mat-paginator #growerPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
              </div>
              <div class="d-block btnWrapper">
                <div class="button-group-space">
                  <button mat-raised-button class="btns" [matMenuTriggerFor]="exportMenu" [disabled]="growerOrderDataSource.data.length <= 0" data-testid="btn-export-to-excel">
                    Export to Excel
                  </button>
                  <mat-menu #exportMenu="matMenu" xPosition="after" class="context-meun-dropdown">
                    <button mat-menu-item (click)="exportToExcel()" data-testid="btn-export-reservation">Reservation</button>
                    <button mat-menu-item (click)="exportReconciliationAtAccountLevel()" data-testid="btn-export-recon-account">Reconciliation at Account Level</button>
                    <button mat-menu-item (click)="exportReconciliationAtParentAccountLevel()" data-testid="btn-export-recon-parent-account">Reconciliation at Parent Account Level</button>
                  </mat-menu>
                  <button mat-raised-button *ngIf="!readOnlyAccess" class="btns" (click)="createNewOrder()" data-testid="btn-create-new-grower-order">Create New Reservation</button>
                </div>
              </div>
            </div>
          </div>
          <div class="seedReserveContainer">
          <div class="tableContainer growertableContainer table-mobile-landing">
            <table mat-table #growerTable [dataSource]="growerOrderDataSource" matSort matSortDirection="desc" class="matTables">
              <ng-container matColumnDef="growerName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="growerName seed-grid-header"> Grower </th>
                <p class="d-sm-block d-md-none">Grower</p>
                <td mat-cell *matCellDef="let element" class="order-info showOnMobile" (click)="navigateToSingleAccount(element, false)">
                  <p class="grower-name">
                    <a>
                      <p class="d-sm-block d-md-none">Grower</p>
                      {{element.growerName}}
                    </a>
                  </p>
                  <p>{{element.growerAddress}}</p>
                </td>
              </ng-container>
              <ng-container matColumnDef="accountName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="locationDetails text-center"> Account Name </th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-block d-sm-block d-md-none sm-block">Account Name</div>
                  <div class="order-info defaultCursor">
                    <p class="grower-name">
                      {{element.shiptToAccountName}}
                    </p>
                    <p>{{element.address1 || element.address2}}, {{element.city}}, {{element.state}} {{element.zipCode}}</p>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="shipToAccount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderId seed-grid-header"> Account #</th>
                <td mat-cell *matCellDef="let element" class="showOnMobile">
                  <p class="d-sm-block d-md-none fontSize m-0" [attr.data-testid]="element.shipToAccount">Account #</p>
                  {{element.shipToAccount}}
                </td>
              </ng-container>
              <ng-container matColumnDef="seller">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderId seed-grid-header"> Seller</th>
                <td mat-cell *matCellDef="let element" class="showOnMobile">
                  <p class="d-sm-block d-md-none fontSize m-0" [attr.data-testid]="element.sellerName">Seller</p>
                  {{element.sellerName}}
                </td>
              </ng-container>
              <ng-container matColumnDef="orderID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderId seed-grid-header"> Seed Reservation ID</th>
                <td mat-cell *matCellDef="let element" class="showOnMobile">
                  <p class="d-sm-block d-md-none fontSize m-0">Seed Reservation ID</p>
                  <div class="">
                    <span class="link cursor-pointer">
                      <a href="#" (click)="navigateToSingleAccount(element); $event.preventDefault();">{{element.orderID}}</a>
                    </span>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="unit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="euivUnitBg seed-grid-header"> Total Units </th>
                <td mat-cell *matCellDef="let element" class="showOnMobile">
                  <p class="d-sm-block d-md-none fontSize m-0">Equiv Units(BG)</p>
                  {{commonService.getFormatedNumber(element.unit) | number}}
                </td>
              </ng-container>
              <ng-container matColumnDef="contextMenu">
                <th mat-header-cell *matHeaderCellDef class="actionBtn">&nbsp;</th>
                <td mat-cell *matCellDef="let element" class="text-left">
                  <div>
                    <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu" [attr.data-testid]="'btn-context-menu-' + element.orderID">
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                      <button mat-menu-item (click)="navigateToSingleAccount(element, true); $event.preventDefault();">Edit Reservation</button>
                      <button  *ngIf="!readOnlyAccess && !isMobile" mat-menu-item (click)="navigateToReconcileReservation(element); $event.preventDefault();">Convert/Reconcile Reservation</button>
                      <button *ngIf="!readOnlyAccess" mat-menu-item (click)="deleteReservation(element.orderID)">Delete Reservation</button>
                    </mat-menu>
                  </div>
                </td>
                <td mat-footer-cell *matFooterCellDef class="xs-none">  </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;" class="hideOnMobile"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>
